
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"#0D69D5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_106_1656)"}},[_c('path',{attrs:{"d":"M11.639 9.746l-.773.773a2.64 2.64 0 01-3.728 0l-.773-.773L.906 15.17c.207.099.434.159.678.159H16.42c.243 0 .471-.06.678-.159l-5.46-5.424zM17.842 3.578l-5.46 5.424 5.46 5.424c.099-.206.158-.434.158-.678V4.256c0-.244-.06-.472-.158-.678zM.159 3.578A1.564 1.564 0 000 4.256v9.492c0 .244.06.472.159.678l5.459-5.424-5.46-5.424z"}}),_c('path',{attrs:{"d":"M16.42 2.672H1.584c-.244 0-.471.06-.678.158l6.977 6.942c.617.617 1.62.617 2.237 0l6.978-6.942a1.563 1.563 0 00-.678-.158z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_106_1656"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    